import { TranslatableFieldSpec } from "@redotech/redo-merchant-app-common/components/translations/translation-field-editors";
import { StepTranslationElement } from "./step-translations";
import { normalizeTranslation } from "./translation-save-diff";

const collapse = (value: string) => value.replace(/\s+/g, " ").trim();

function comparable(kind: TranslatableFieldSpec["kind"], raw: string): string {
  const value = normalizeTranslation(kind, raw);
  if (kind !== "html") {
    return collapse(value);
  }
  const { body } = new DOMParser().parseFromString(value, "text/html");
  return collapse(body.textContent ?? "");
}

export function isTranslationStale({
  kind,
  sourceText,
  currentText,
}: {
  kind: TranslatableFieldSpec["kind"];
  sourceText: string | null | undefined;
  currentText: string;
}): boolean {
  return (
    sourceText != null &&
    comparable(kind, sourceText) !== comparable(kind, currentText)
  );
}

export function staleTranslationLanguages<Language extends string>({
  elements,
  translations,
}: {
  elements: readonly StepTranslationElement[];
  translations: readonly {
    elementId: string;
    field: string;
    language: Language;
    sourceText: string | null;
  }[];
}): ReadonlySet<Language> {
  const fields = new Map<string, StepTranslationElement["field"]>(
    elements.flatMap(({ elementId, field }) =>
      elementId ? [[`${elementId} ${field.field}`, field] as const] : [],
    ),
  );
  const stale = new Set<Language>();
  for (const row of translations) {
    const field = fields.get(`${row.elementId} ${row.field}`);
    if (
      field &&
      isTranslationStale({
        kind: field.kind,
        sourceText: row.sourceText,
        currentText: field.source,
      })
    ) {
      stale.add(row.language);
    }
  }
  return stale;
}
